import { ModalWindow } from "../../../shared/ui/modal";
import DonationBtn from "../../../shared/ui/DonationBtn/DonationBtn";
import React from "react";
import { ProjectSupport } from "../model/types";


export function ProjectSupportComponent({modal, setModal}: ProjectSupport) {
    return (
        <ModalWindow updateModalState={setModal}
                    modalShow={modal}
                    logo={true}
                    position={'center'}
                    title={'Сделайте свой вклад в развитие проекта'}>
                    <div style={{maxWidth: '444px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
                        <p>Нам важна ваша поддержка 💪 <br />Пожертвования пойдут на развитие проекта и обеды разработчиков, 
                            чтобы они могли чувствовать себя еще более комфортно в своих 
                            непрерывных битвах с багами. 
                        </p>
                        <p>Но не думайте, что наша команда только ест и шутит! Мы трудимся 
                            день и ночь, чтобы создать удобный продукт, который сделает вашу 
                            жизнь и работу легче.
                        </p>
                        <p>Даже если вы передумали пожертвовать, то наши разработчики уже 
                            готовятся к 🍔 бургерным слезам.
                        </p>
                        <DonationBtn redirectTo='https://yoomoney.ru/to/4100118394034625' title='Поддержать проект'/>
                    </div>
        </ModalWindow>
    )
}